<template>
  <div class="login-form">
    <div class="login-header">
      <h1 class="login-title" :style="getPrimaryColor">
        <i class="ph ph-user-switch"></i> Tenant Login
      </h1>
      <div class="nav-link text-right">
            Don't have an account ? 
            <router-link to="/ap/reg" class="fw-bold" :style="getPrimaryColor">
              SignUp!
            </router-link>
          </div>

      
    </div>

    <div class="divider">
      <span class="line"></span>
      <span class="line"></span>
    </div>
    <el-form v-if="currentForm === 'default'" class="log-form" :model="verification" ref="verification"
      @submit.native.prevent="verifyEmail('verification')">
      <el-form-item prop="email">
        User name <span class="text-danger">*</span>
        <el-input v-model="verification.email" placeholder="Email or Mobile" autocomplete="off"></el-input>
        <p class="error" v-if="getErrors && getErrors.email">
          {{ getErrors.verification_email }}
        </p>
      </el-form-item>

      <el-form-item class="mt-1">
        <div class="forgot-login-row  space-between">
          <el-button type="primary" size="medium" round native-type="button" class="login-button full-width"
            @click="verifyEmail('verification')" :loading="submitLoading" :style="getButtonStyles">
            Click here to verify
          </el-button>
        </div>
      </el-form-item>

      <p class="error" v-if="getCompaniesByEmail && !getCompaniesByEmail.status">
        {{ getCompaniesByEmail.message }}
      </p>

      <div class="divider">
        <span class="line"></span>
        <span class="divider-text">OR</span>
        <span class="line"></span>
      </div>

        <div class="forgot-login-row">
          <a @click="goToBuilder" class="forgot-password-link" :style="getPrimaryColor">
            Start building your app — log in to the Builder
          </a>
        </div>
    </el-form>

    <!-- Verified Sign-In Form -->
    <el-form v-if="currentForm === 'VERIFIED'" :model="signin" ref="signin" class="log-form"
      @submit.native.prevent="submitForm('signin')">
      <h3>Welcome {{ getUserName }}!</h3>

      <el-form-item prop="email">
        User name <span class="text-danger">*</span>
        <el-input v-model="signin.email" placeholder="Email or Mobile" disabled autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item class="mb-1" prop="workspace">
        Workspace <span class="text-danger">*</span>
        <el-select v-model="signin.workspace" filterable placeholder="Select" style="width: 100%">
          <el-option v-for="item in getWorkspaceList" :key="item.contact_id" :label="item.name"
            :value="item.contact_id"></el-option>
        </el-select>
        <p class="error" v-if="getErrors && getErrors.workspace">
          {{ getErrors.workspace }}
        </p>
      </el-form-item>

      <el-form-item class="mb-1" prop="password">
        Password <span class="text-danger">*</span>
        <div class="password-input-wrapper">
          <el-input :type="passwordType" placeholder="Enter Password" v-model="signin.password"
            autocomplete="off"></el-input>
          <span class="password-toggle" @click="passwordType = passwordType === 'password' ? 'text' : 'password'">
            <i v-if="passwordType === 'password'" class="ph ph-eye"></i>
            <i v-if="passwordType === 'text'" class="ph ph-eye-slash"></i>
          </span>
        </div>
        <p class="error" v-if="getErrors && getErrors.password">
          {{ getErrors.password }}
        </p>
      </el-form-item>

      <el-form-item class="mt-1">
        <div class="forgot-login-row space-between">
          <el-button type="primary" size="medium" round native-type="button" class="login-button full-width"
            @click="submitForm('signin')" :loading="submitLoading" :style="getButtonStyles">
            Log In
          </el-button>
        </div>
      </el-form-item>

      <p class="error" v-if="getCompaniesByEmail && !getCompaniesByEmail.status">
        {{ getCompaniesByEmail.message }}
      </p>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import CryptoJS from "crypto-js";
// import { setApplicationSetup } from "@/repo/appSettingRepo";
import UserHelper from "@/mixins/UserHelper";
import WhiteLabelConfig from "@/config/app";

export default {
  data() {
    return {
      applicationSettings: {},
      currentForm: "default",
      verification: {
        email: "",
      },
      signin: {
        email: "",
        password: "",
        workspace: "",
      },
      passwordType: "password",
      submitLoading: false,
      getErrors: null,
    };
  },
  mixins: [UserHelper],
  computed: {
    ...mapGetters("company", ["getCompaniesByEmail"]),
    ...mapGetters("auth", [
      "getAuthenticationStatus",
      "getUserSignInErrors"
    ]),
    getButtonStyles() {
      return `background-color:#${this.applicationSettings.SECONDARY_COLOR} !important; background-image: linear-gradient(-240deg,#${this.applicationSettings.PRIMARY_COLOR}, #${this.applicationSettings.SECONDARY_COLOR});color:#FFFFFF  !important;border-color:#${this.applicationSettings.SECONDARY_COLOR} !important;`;
    },
    getPrimaryColor() {
      return `color:#${this.applicationSettings.PRIMARY_COLOR} !important;`;
    },
    getUserName() {
      const companies = this.getCompaniesByEmail || [];
      return companies?.status && companies.companies?.length
        ? `${companies.companies[0].first_name} ${companies.companies[0].last_name}`
        : "";
    },
    getEmail() {
      const companies = this.getCompaniesByEmail || [];
      return companies?.status && companies.companies?.length
        ? companies.companies[0].email
        : "";
    },
    getWorkspaceList() {
      const companies = this.getCompaniesByEmail || [];
      return companies?.status && companies.companies?.length
        ? companies.companies
        : [];
    },
    isEmailValid() {
      const email = this.verification.email?.trim().toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  },
  created() {
    this.navigation();
  },
  mounted() {
    this.$store.commit("company/resetCompaniesByEmail");
    this.applicationSettings = WhiteLabelConfig;
    this.navigation();
  },
  methods: {
    async navigation() {
      if (this.getCompaniesByEmail?.status) {
        this.currentForm = "VERIFIED";
        this.signin.email = this.getEmail;
      }
    },
    async verifyEmail(formType, e) {
      if (e) e.preventDefault();
      this.verification.email = this.verification.email.trim().toLowerCase();
      if (!this.verification.email) {
        this.getErrors = { verification_email: "Email is required!" };
        return;
      }
      if (!this.isEmailValid) {
        this.getErrors = { verification_email: "Enter a valid email address!" };
        return;
      }

      this.getErrors = null; // Clear any existing errors

      this.$refs[formType].validate(async (valid) => {
        if (!valid) return false;
        this.submitLoading = true;
        await this.$store.dispatch("company/fetchCompaniesByEmail", {
          email: this.verification.email,
        });
        if (this.getCompaniesByEmail?.status) {
          this.currentForm = "VERIFIED";
          this.signin.email = this.getEmail;
        }
        this.submitLoading = false;
      });
    },
    async submitForm(formType) {
      this.signin.email = this.signin.email.trim().toLowerCase();

      if (!this.signin.email) {
        this.getErrors = { email: "Email is required!" };
        return;
      }
      if (!this.isEmailValid) {
        this.getErrors = { email: "Enter a valid email address!" };
        return;
      }

      if (!this.signin.workspace) {
        this.getErrors = { workspace: "Workspace is required!" };
        return;
      }
      if (!this.signin.password) {
        this.getErrors = { password: "Password is required!" };
        return;
      }
      this.getErrors = null;

      this.$refs[formType].validate(async (valid) => {
        if (!valid) return false;
        this.submitLoading = true;
        await this.$store.dispatch("applicationUsers/fetchSetUserSignInVerify", {
          contact_id: this.signin.workspace,
          password: this.signin.password,
        });

        if (this.getAuthenticationStatus) {
          console.log("Login Info",this.getAuthenticationStatus);
          this.$router.push({path:"/ap/welcome"});
          // let params = {
          //   slug: this.signin.workspace,
          // };
          // await this.$store.dispatch("company/fetchCompanyById", params);
          // this.$store.commit("errors/reset", null, { root: true });
          // let redirect_url = "";
          // if (this.$route?.query?.redirect_url) {
          //   let reb64 = CryptoJS.enc.Hex.parse(this.$route.query.redirect_url);
          //   let bytes = reb64.toString(CryptoJS.enc.Base64);
          //   let decrypt = CryptoJS.AES.decrypt(bytes, "esignsRedirect");
          //   let plain = decrypt.toString(CryptoJS.enc.Utf8);
          //   let obj = JSON.parse(plain);
          //   redirect_url = obj.path;
          // }
          // this.$store.commit("auth/setAppMode", true, { root: true });
          // await setApplicationSetup();
          // await this.checkAndUpdateData(redirect_url);
        } else {
          this.$notify.error({
            title: "Error",
            message: this.getUserSignInErrors?.message || "Error while signing in",
          });
          this.submitLoading = false;
        }
      });
    },
    goToBuilder() {
      this.$router.push({ path: '/signin' })
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: #196392 !important;
}

a:hover {
  text-decoration: underline !important;
  color: #196392 !important;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.forgot-login-row {
  display: flex;
  justify-content: space-between;
}

.full-width {
  width: 100%
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider .line {
  height: 1px;
  width: 100%;
  background-color: #ccc;
}

.divider-text {
  padding: 0 10px;
}

.password-input-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error {
  color: red;
}
</style>
